import { GetServerSidePropsContext } from 'next'

import { serverSidePropsFor } from '@/utils/helpers.server'

import TopPage from '..'

export const getServerSideProps = async (context: GetServerSidePropsContext) =>
  serverSidePropsFor(
    `${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/pages/top/${context.query.slug}/${context.query.subSlug}.json`,
  )

export default TopPage
